import React from 'react';
import { Popup } from 'semantic-ui-react';
import HolidayIcon from '@material-ui/icons/BeachAccess';
import TimesheetHolidayName from 'components/TimesheetHolidayName';
import { EntityId } from 'services/entities/types';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';

interface OwnProps {
    timesheetEntityId?: EntityId;
    timesheetDate: TimesheetHolidayDate;
}

type Props = OwnProps;

export default class TimesheetHolidayIcon extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { timesheetDate, timesheetEntityId } = this.props;

        if (!timesheetEntityId) {
            return null;
        }

        return (
            <Popup
                trigger={
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center'
                        }}
                    >
                        <HolidayIcon
                            htmlColor="rgb(164, 33, 106)"
                            style={{
                                fontSize: 17,
                                marginLeft: 3
                            }}
                        />
                    </div>
                }
                mouseEnterDelay={300}
                content={
                    <TimesheetHolidayName
                        timesheetDate={timesheetDate}
                        timesheetEntityId={timesheetEntityId}
                    />
                }
                inverted
                basic
            />
        );
    }
}
